import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import BannerValidationSchema from "../Validations/BannerValidation";

function Testimonials({ States, open, onClose, testmonialsEdit, onSuccess }) {
  const [state, setState] = useState([]);
  const [universities, setUniversity] = useState([]);
  const [courses, setCourse] = useState([]);
  console.log(state);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      imageUrl: testmonialsEdit?.imageUrl || "",
      firstName: testmonialsEdit?.firstName || "",
      lastName: testmonialsEdit?.lastName || "",
      content: testmonialsEdit?.content || "",
      stateId: testmonialsEdit?.stateId || "",
      universityId: testmonialsEdit?.universityId || "",
      courseId: testmonialsEdit?.courseId || "",
      professions: testmonialsEdit?.professions || [],
      displayOrder: testmonialsEdit?.displayOrder || "",
      active: testmonialsEdit?.active ?? "true",
    },

    validationSchema: BannerValidationSchema.testimonialsValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      console.log("hello", values);
      try {
        let response;
        // If it's Edit data it will call Update api
        if (testmonialsEdit?.id) {
          response = await api.put(
            `/api/v1/testimonials/${testmonialsEdit?.id}`,
            values,
          );
          console.log(values);
        }

        // Else it's Add data it will call Add api
        else {
          console.log(values);

          response = await api.post("/api/v1/testimonials", values);
        }
        // Show success toast
        toast.success(
          `Testimonial ${
            testmonialsEdit?.id ? "updated" : "added"
          } successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          },
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      }
    },
  });
  //  State Get API call
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statesRes, universityRes, courseRes] = await Promise.all([
          api.get("/getAllStates"),
          api.get("/getAllUniversities"),
          api.get("/getCourses", { params: { active: true } }),
        ]);

        setState(statesRes.data.data);
        setUniversity(universityRes.data.data);
        setCourse(courseRes.data.data);
      } catch (error) {
        console.log("Error:", error);
      }
    };

    fetchData();
  }, []);
  // Filter the courses based on selected state and university
  const filteredCourses = courses.filter(
    (c) => c.universityId === formik.values.universityId,
  );
  return (
    <>
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {testmonialsEdit && Object.keys(testmonialsEdit).length > 0
              ? "Update Testimonials"
              : "Add Testimonials"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <TextField
              label="Image URL"
              name="imageUrl"
              value={formik.values.imageUrl}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.imageUrl && Boolean(formik.errors.imageUrl)}
              helperText={formik.touched.imageUrl && formik.errors.imageUrl}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="First Name"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.firstName && Boolean(formik.errors.firstName)
              }
              helperText={formik.touched.firstName && formik.errors.firstName}
              {...TEXT_FIELD_STYLES.standard}
              required
            />
            <TextField
              label="Last Name"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
              {...TEXT_FIELD_STYLES.standard}
              required
            />
            <TextField
              label="Content"
              name="content"
              value={formik.values.content}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.content && Boolean(formik.errors.content)}
              helperText={formik.touched.content && formik.errors.content}
              {...TEXT_FIELD_STYLES.standard}
              required
            />
            <FormControl
              fullWidth
              error={formik.touched.stateId && Boolean(formik.errors.stateId)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="state-label">State</InputLabel>

              <Select
                labelId="state-label"
                id="state"
                name="stateId"
                value={formik.values.stateId || ""}
                onChange={(e) => {
                  formik.setFieldValue("stateId", e.target.value);
                }}
                onBlur={formik.handleBlur}
                label="State"
              >
                {state.map((s) => (
                  <MenuItem value={s.id} key={s.id}>
                    {s.name}
                  </MenuItem>
                ))}
              </Select>

              {formik.touched.stateId && formik.errors.stateId && (
                <FormHelperText>{formik.errors.stateId}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={
                formik.touched.universityId &&
                Boolean(formik.errors.universityId)
              }
              sx={{ mt: 2 }}
            >
              <InputLabel id="state-label">University</InputLabel>

              <Select
                labelId="university-label"
                id="university"
                name="universityId"
                value={formik.values.universityId || ""}
                onChange={(e) => {
                  formik.setFieldValue("universityId", e.target.value);

                  // reset course when university changes
                  formik.setFieldValue("courseId", "");
                }}
                onBlur={formik.handleBlur}
                label="University"
              >
                {universities.map((u) => (
                  <MenuItem value={u.id} key={u.id}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>

              {formik.touched.universityId && formik.errors.universityId && (
                <FormHelperText>{formik.errors.universityId}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.courseId && Boolean(formik.errors.courseId)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="state-label">Course</InputLabel>

              <Select
                labelId="course-label"
                id="course"
                name="courseId"
                value={formik.values.courseId || ""}
                onChange={(e) => {
                  formik.setFieldValue("courseId", e.target.value);
                }}
                onBlur={formik.handleBlur}
                label="Course"
                disabled={!formik.values.universityId} // disable if no university
              >
                {filteredCourses.map((course) => (
                  <MenuItem value={course.id} key={course.id}>
                    {course.courseName}
                  </MenuItem>
                ))}
              </Select>

              {formik.touched.courseId && formik.errors.courseId && (
                <FormHelperText>{formik.errors.courseId}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={
                formik.touched.professions && Boolean(formik.errors.professions)
              }
              sx={{ mt: 2 }}
            >
              <InputLabel id="professions-label">Professions</InputLabel>
              <Select
                labelId="professions-label"
                id="professions"
                name="professions"
                multiple
                value={formik.values.professions}
                onChange={(e) => {
                  const {
                    target: { value },
                  } = e;
                  formik.setFieldValue(
                    "professions",
                    typeof value === "string" ? value.split(",") : value,
                  );
                }}
                onBlur={formik.handleBlur}
                label="Professions"
                renderValue={(selected) => selected.join(", ")}
              >
                <MenuItem value="Software Engineer">Software Engineer</MenuItem>
                <MenuItem value="Tech Lead">Tech Lead</MenuItem>
                <MenuItem value="React Developer">React Developer</MenuItem>
                <MenuItem value="Back end Lead">Back end Lead</MenuItem>
              </Select>
              {formik.touched.professions && formik.errors.professions && (
                <FormHelperText>{formik.errors.professions}</FormHelperText>
              )}
            </FormControl>
            <TextField
              label="DisplayOrder"
              name="displayOrder"
              type="number"
              inputProps={{ min: 0 }}
              value={formik.values.displayOrder}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.displayOrder &&
                Boolean(formik.errors.displayOrder)
              }
              helperText={
                formik.touched.displayOrder && formik.errors.displayOrder
              }
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>
            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button type="submit" {...BUTTON_STYLES.primary}>
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default Testimonials;
